import { createContext } from 'react';
import { IModifierGroups } from 'types';

export type TSortBy = '' | 'ModifierGroupsA-Z' | 'ModifierGroupsZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'assignRestaurants'
	| 'errorUpdatingModifierGroup'
	| 'errorModGroupHasPortions'
	| 'editRestaurantProperties'
	| 'editModifiersTemplate';

export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface IModifierGroupState {
	needRefetchData: boolean;
	modifierGroups: IModifierGroups;
	searchString: string;
	rememberMyChoice: boolean;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForAssignRestaurants: string;
	IDForEditRestaurantProperties: string;
	IDForEditModifiersTemplate: string;
	isInitializedSelectCustomerModal: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const modifierGroupInitialState: IModifierGroupState = {
	needRefetchData: false,
	modifierGroups: { modifierGroupsCount: 0, modifierGroups: [] },
	searchString: '',
	rememberMyChoice: true,
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForAssignRestaurants: '',
	IDForEditRestaurantProperties: '',
	IDForEditModifiersTemplate: '',
	isInitializedSelectCustomerModal: false,
	typeOfModalWindow: null,
};

export interface IModifierGroupContext extends IModifierGroupState {
	refetchData(value: boolean): void;
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	toggleRememberMyChoice(): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForAssignRestaurants(value: string): void;
	setIDForEditRestaurantProperties(value: string): void;
	setIDForEditModifiersTemplate(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const ModifierGroupContext = createContext<IModifierGroupContext>({
	refetchData: () => undefined,
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	toggleRememberMyChoice: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForAssignRestaurants: () => undefined,
	setIDForEditRestaurantProperties: () => undefined,
	setIDForEditModifiersTemplate: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...modifierGroupInitialState,
});
